/*Linea de crédito */
export class CreditLine {
    /*Monto aprobado */
    public approvedAmount: number;
    /*Monto consumido */
    public usedAmount: number;
    /*Monto disponible */
    public availableAmount: number;
    /*Porcentaje de monto usado respecto al monto aprobado */
    public usedAmountRate: number;
    /*Simbolo de moneda */
    public currencySymbol: string;
    /**Monto correspondiente al carrito de compras */
    public shoppingCartAmount: number;
}